<div class="inset-0 flex flex-col min-w-0 overflow-hidden" style="width: 100vw; height: calc(100vh - 160px)">
    <!-- Main -->
    <div
        cdkScrollable
        [ngStyle]="{ padding : isMobileResolution ? '0 !important' : '25px !important' }"
        class="flex-auto xs:p-0 sm:p-0 md:p-0 lg:p-10 xl:p-10" style="height: 100%">

        <div>
            <ng-content select="[infobar]"></ng-content>
        </div>
        <!-- CONTENT GOES HERE -->
        <div style="display: flex; flex-direction: row; width: 100%; height: 100%">
            <!--LEFT-->
            <div style="width: 100%; overflow: hidden">
                <div *ngIf="selectedMenu !== 'posMenu' && isPosRoute"
                     style="position: absolute; right: 0;">
                    <button mat-icon-button (click)="goToPosMenu()">
                        <mat-icon svgIcon="mat_outline:close"></mat-icon>
                    </button>
                </div>
                <ng-container *ngIf="selectedMenu === 'findProduct'">
                    <div
                        class="header-menu bg-default dark:bg-transparent"
                        style="padding-bottom: 0 !important; padding-right: 0 !important;">
                        <div class="flex-1 min-w-0">
                            <!-- Title -->
                            <div class="mt-2">
                                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                                    <ng-content select="[heading]"></ng-content>
                                </h2>
                            </div>
                            <!-- Breadcrumbs -->
                            <div>
                                <ng-content select="[breadcrumbs]"></ng-content>
                            </div>
                        </div>
                        <!-- Actions -->
                        <div
                            class="flex-shrink-0 items-center mt-6 sm:mt-2" style="display: flex">
                            <ng-container *ngTemplateOutlet="contentBlock"></ng-container>
                        </div>
                        <ng-template #contentBlock>
                            <ng-content select="[icons]"></ng-content>
                        </ng-template>
                    </div>
                    <ng-content select="[content]"></ng-content>
                </ng-container>
                <ng-container *ngIf="selectedMenu === 'posMenu'">
                    <ng-content select="[posMenu]"></ng-content>
                </ng-container>
                <ng-container *ngIf="selectedMenu === 'findByNumber'">
                    <ng-content select="[findByNumber]"></ng-content>
                </ng-container>
            </div>
            <!-- RIGHT -->
            <ng-content select="[receipt]"></ng-content>
        </div>

    </div>

</div>
